import type { BookingConfirmationSummary } from '@massilia/queries'

import { formatPrice } from '@/utils/format-price'

export interface PaymentConfirmationBookingData {
  customerEmail?: string
  bookingRef?: string
  customerPhone?: string
  depositAmountLabel?: string
  depositDeadlineLabel?: string
  paidAmountLabel?: string
  remainingAmountLabel?: string
  totalAmountLabel?: string
}

export function buildPaymentConfirmationBookingDataFromSummary(
  summary: BookingConfirmationSummary | undefined,
  bookingRefFallback?: string
): PaymentConfirmationBookingData {
  if (!summary) {
    return { bookingRef: bookingRefFallback }
  }

  const totalAmountLabel = formatPrice(summary.totalPriceCents / 100)
  const depositAmountCents = summary.depositAmountCents
  const depositAmountLabel =
    typeof depositAmountCents === 'number'
      ? formatPrice(depositAmountCents / 100)
      : totalAmountLabel
  const remainingCents =
    typeof depositAmountCents === 'number'
      ? summary.totalPriceCents - depositAmountCents
      : summary.totalPriceCents
  const depositDeadlineLabel = summary.installmentPaymentDeadline
    ? formatDate(summary.installmentPaymentDeadline)
    : undefined

  return {
    customerEmail: summary.client.email ?? undefined,
    bookingRef: summary.bookingReference,
    customerPhone: summary.client.phone ?? undefined,
    depositAmountLabel,
    depositDeadlineLabel,
    paidAmountLabel: formatPrice(0),
    remainingAmountLabel: formatPrice(remainingCents / 100),
    totalAmountLabel,
  }
}

function formatDate(isoDate: string): string {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) return isoDate
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date)
}
